/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import React, { useContext, useEffect } from 'react';
import { AuthContext } from '@xometry/auth-context';
import { Box, Flex, theme } from '@xometry/xometry_loft';
import { css } from '@emotion/react';
import RegisterLayout from '../Layout';
import XACRegisterForm from './XACRegisterForm';
import Account from '../../../services/account';
import { WORKCENTER_ORIGIN } from '../../../config';
import { getPrimaryPartnerId } from '../../../utils/helpers';

const XACRegistration = () => {
  const { isLoading, user } = useContext(AuthContext);
  if (isLoading) return <div />;

  useEffect(() => {
    if (window.analytics)
      window.analytics.page('Xometry Pay Advance Card Registration');
    const account = new Account();

    account
      .getStripeUser()
      .then((res) => {
        if (res.type === 'express') {
          window.location.href = `${WORKCENTER_ORIGIN}/pay/shop-finances`;
        }
      })
      .catch((err) => {
        console.error(err);
      });

    async function checkUserStatus() {
      let stripeUserMeta: any = await account.getMe();

      // Retry logic to verify that the partner account has settled.
      if (!stripeUserMeta) stripeUserMeta = await account.getMe();
      if (!stripeUserMeta) stripeUserMeta = await account.getMe();
      if (!stripeUserMeta) stripeUserMeta = await account.getMe();

      if (stripeUserMeta && stripeUserMeta.user && !stripeUserMeta.can_card) {
        // Reroute to Shop Finances if the user cannot apply for the Advance Card.
        window.location.href = `${WORKCENTER_ORIGIN}/pay/shop-finances`;
      } else if (
        stripeUserMeta &&
        stripeUserMeta.user &&
        stripeUserMeta.user.card_id
      ) {
        window.location.href = `${WORKCENTER_ORIGIN}/job-board`;
      } else if (getPrimaryPartnerId(user) && !stripeUserMeta) {
        window.location.href = '/account/register-shop-finances';
      } else if (!getPrimaryPartnerId(user)) {
        window.location.href = '/account/register-supplier';
      }
    }
    checkUserStatus();
  }, []);

  return (
    <RegisterLayout flow="XAC" authenticated>
      <Flex
        flexDirection="column"
        textAlign="center"
        width={['350px', '516px']}
        marginBottom={['20px', '60px', '40px']}
      >
        <h1
          css={css`
            color: ${theme.colors.darkBlues[100]};
            font-weight: ${theme.fontWeights.regular};
            font-size: 28px;
            margin-top: 0px;
            margin-bottom: 8px;
            padding-top: 32px;
            line-height: ${theme.lineHeights[7]};

            ${theme.mediaQueries.small} {
              font-size: 36px;
              margin-top: initial;
            }
          `}
        >
          Get the Xometry Advance Card
        </h1>
        <Box maxWidth="443px" margin="auto">
          <Box fontSize={theme.fontSizes[2]} textAlign="center" marginTop="8px">
            No fees, interest, bills, credit checks, or impact on your credit
            rating.
          </Box>
          <Box marginTop="36px" marginBottom="36px">
            <XACRegisterForm />
          </Box>
        </Box>
      </Flex>
    </RegisterLayout>
  );
};

export default XACRegistration;
